import script from "./AtomInputBrands.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomInputBrands.vue?vue&type=script&lang=ts&setup=true"

import "./AtomInputBrands.vue?vue&type=style&index=0&id=b4c46124&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4c46124"]])

export default __exports__